import { render, staticRenderFns } from "./list-company.vue?vue&type=template&id=4d04b0fe"
import script from "./list-company.vue?vue&type=script&lang=js"
export * from "./list-company.vue?vue&type=script&lang=js"
import style0 from "./list-company.vue?vue&type=style&index=0&id=4d04b0fe&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports